export default "__VITE_ASSET__ChcWM42Z__"